import { useCallback } from 'react';

import { cx } from '@libs/classnames';
import { DateView } from '@ui/components/DateView';
import { InfiniteScroll } from '@ui/components/InfiniteScroll';

import { NewsPost } from '@features/shared/api/typings';

import styles from './NewsList.module.css';

type Props = {
  className?: string;
  news: NewsPost[];
  onNewsItemClick: (newsPost: NewsPost) => void;
  onLoadMore: () => void;
  hasMore: boolean;
  isModal?: boolean;
};

export function NewsList({
  className,
  news,
  onNewsItemClick,
  onLoadMore,
  hasMore,
  isModal,
}: Props) {
  return (
    <InfiniteScroll
      scrollableClassName={className}
      fetchMore={onLoadMore}
      hasMore={hasMore}
      itemsLength={news.length}
      hideLoader={!isModal}
    >
      <div className={cx(styles.newsList, { [styles.isModal]: isModal })}>
        {news.map((newsArticle) => (
          <NewsListItem
            key={newsArticle.id}
            newsArticle={newsArticle}
            onClick={onNewsItemClick}
            preset={isModal ? 'l' : 's'}
          />
        ))}
      </div>
    </InfiniteScroll>
  );
}

type NewsListItemProps = {
  newsArticle: NewsPost;
  onClick: (newsArticle: NewsPost) => void;
  preset: 's' | 'l';
};

export function NewsListItem({ newsArticle, onClick, preset }: NewsListItemProps) {
  const handleClick = useCallback(() => {
    onClick(newsArticle);
  }, [newsArticle, onClick]);

  return (
    <div
      className={cx(
        styles.newsItem,
        {
          [styles.promoted]: newsArticle.promoted,
        },
        styles[preset],
      )}
      onClick={handleClick}
    >
      <div className={styles.title}>{newsArticle.title}</div>
      <div className={styles.date}>
        <DateView showTime date={newsArticle.publishTimestampMs} />
      </div>
    </div>
  );
}
